import type { PcmBuffer } from './types';

// Channel-count adjustments. Mixing DOWN is a true average; mixing UP
// duplicates (rather than panning/spreading), which is the right default
// for drum one-shots — stereo spread is a mangle verb's job, not a
// pipeline primitive.

export function toMono(pcm: PcmBuffer): PcmBuffer {
  if (pcm.channels.length === 0) return pcm;
  if (pcm.channels.length === 1) {
    return { sampleRate: pcm.sampleRate, channels: [pcm.channels[0]!.slice()] };
  }
  const len = pcm.channels[0]!.length;
  const out = new Float32Array(len);
  const invN = 1 / pcm.channels.length;
  for (let i = 0; i < len; i++) {
    let sum = 0;
    for (let c = 0; c < pcm.channels.length; c++) sum += pcm.channels[c]![i]!;
    out[i] = sum * invN;
  }
  return { sampleRate: pcm.sampleRate, channels: [out] };
}

export function toStereo(pcm: PcmBuffer): PcmBuffer {
  if (pcm.channels.length >= 2) {
    // Pass only L and R through — anything wider collapses on commit
    // (WAV encoder caps at 2). Still copy so callers can mutate freely.
    return {
      sampleRate: pcm.sampleRate,
      channels: [pcm.channels[0]!.slice(), pcm.channels[1]!.slice()],
    };
  }
  if (pcm.channels.length === 0) {
    return { sampleRate: pcm.sampleRate, channels: [] };
  }
  const src = pcm.channels[0]!;
  return {
    sampleRate: pcm.sampleRate,
    channels: [src.slice(), src.slice()],
  };
}
